import React from 'react'

import { Anchor, AnchorProps, MantineSize } from '@mantine/core'
import cn from 'classnames'

import { useMst } from '#state'

import styles from './OutsideAnchor.module.css'

type OutsideAnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  AnchorProps & {
    children: string
    target?: React.HTMLAttributeAnchorTarget
    rel?: string
    withIcon?: boolean
    tracking?: { source: string; to: string }
    fz?: MantineSize | number
  }

export const OutsideAnchor = React.forwardRef<
  HTMLAnchorElement,
  OutsideAnchorProps
>((props, ref) => {
  const {
    children,
    target = '_blank',
    rel = 'noopener noreferrer',
    withIcon = true,
    tracking,
    href,
    ...otherProps
  } = props
  const { trackLinkClicked } = useMst()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (tracking && href) {
      trackLinkClicked({
        linkType: 'external',
        url: href,
        ...tracking,
      })
    }
    otherProps.onClick?.(e)
  }

  return (
    <Anchor
      className={styles.outsideanchor}
      {...otherProps}
      ref={ref}
      href={href}
      target={target}
      rel={rel}
      onClick={handleClick}
    >
      <span>
        {children}
        {withIcon ? (
          <i
            className={cn(
              'fas fa-arrow-up-right-from-square',
              styles.outsideanchor_icon,
            )}
          />
        ) : null}
      </span>
    </Anchor>
  )
})

OutsideAnchor.displayName = 'OutsideAnchor'
